import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  STOCK_TAKING_CAR_MANAGEMENT_SALES_TYPE_CATALOG_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_SALES_TYPE_CATALOG_FAILURE
} from '../constants'

export function* getSalesTypeCatalogsSaga() {
  try {
      const result =  yield call(BFFAgent.Catalogs.getSaleTypes)
      const saleTypesList = result?.data?.data

      yield put({
          type: STOCK_TAKING_CAR_MANAGEMENT_SALES_TYPE_CATALOG_SUCCESS,
          data: saleTypesList
      })
      
  } catch (error) {
    yield put({
      type:   STOCK_TAKING_CAR_MANAGEMENT_SALES_TYPE_CATALOG_FAILURE,
      data: { error }
    })
  }
}
